import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";
import heroDesktop from "../../img/Home/Herodesktop.webp";
import heroMobile from "../../img/Home/Heromob.webp";
import Fade from 'react-reveal/Fade';

function Hero() {
  const { link } = useContext(LinkContext);
  const { t } = useTranslation();

  return (
    <section className="bg-white pt-[60px] xl:pt-[110px]">
      <div className="relative h-[623px] w-full overflow-hidden md:mx-auto md:h-[440px] md:max-w-[1220px] xl:h-[520px]">
        <picture>
          <source media="(min-width: 768px)" srcSet={heroDesktop} />
          <img
            src={heroMobile}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
        </picture>

        <Fade bottom>
        <div className="absolute left-[20px] top-[42px] z-10 w-[272px] text-[#3273B4] md:left-[46px] md:top-[70px] md:w-[560px] xl:left-[48px] xl:top-[82px]">
          <h1 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.5] md:text-[42px]">
            <span className="md:hidden">
              <span className="block">{t("hero.mobileTitle.1")}</span>
              <span className="block">{t("hero.mobileTitle.2")}</span>
              <span className="block">{t("hero.mobileTitle.3")}</span>
            </span>
            <span className="hidden md:block">{t("hero.title")}</span>
          </h1>
          <span className="mt-[8px] block h-[2px] w-[147px]  bg-[#05193A] md:mt-[18px] md:h-[4px] md:w-[178px]" />
          <p className="mt-[20px] xl:max-w-[272px] font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193A] md:max-w-[380px] md:text-[16px]">
            {t("hero.text")}
          </p>
          <a
            href={link}
            className="mt-[29px] inline-flex h-[40px] items-center justify-center rounded-[9px] bg-[#05193A] px-[29px] font-[Inter] text-[14px] font-light text-white transition-colors hover:bg-[#0d2c60] md:mt-[38px] md:h-[42.386px] md:rounded-[10px] md:px-[35px] md:text-[16px]"
          >
            {t("header.openAccount")}
          </a>
        </div>
        </Fade>
      </div>
    </section>
  );
}

export default Hero;
